/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

const vanillaLazy = require('vanilla-lazyload/dist/lazyload');

const {
  cleanSources,
  mapOptions,
  prepareSources,
  isSelector,
  testJQuery,
} = require('./helper');

const lazyStore = {};
const defaultClasses = ['.lazy-load', '.lazy-wl'];
const triggerClass = '.lazy-load';
const isLoadedClass = '.lazy-loaded';

/**
 *
 * @param {string} selector
 * @param {ParentNode=} context
 * @param {Object=} options
 */
function skipLazyLoader(selector, context = document, options = {}) {
  context.querySelectorAll(selector).forEach(el => {
    const opts = mapOptions(options);
    prepareSources(el, opts);
    const { src, srcset } = el.dataset;
    if (src || srcset) {
      if (src) {
        el.src = src;
      }
      if (srcset) {
        el.srcset = srcset;
      }
      el.dataset['wasProcessed'] = true;
      el.classList.add('lazy-loaded');
    }
    cleanSources(el);
  });
}

/**
 *
 * @param {string} selectors
 * @param args
 */
function lazyload(selectors, ...args) {
  let context;
  let options;

  if (args.length === 1) {
    [options] = args;
  }
  if (args.length === 2) {
    [context, options] = args;
  }

  if (options == null) {
    options = {};
  }

  if (options.skip_invisible === false || options.instant_load === true) {
    skipLazyLoader(selectors, context, options);
  }

  document.querySelectorAll(selectors).forEach(el => {
    if (!el.src) {
      el.src =
        'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    }
  });

  selectors.split(',').forEach(selector => {
    const usedSelector =
      defaultClasses.find(
        entry =>
          selector.indexOf(entry) >= 0 && selector.indexOf(isLoadedClass) === -1
      ) || selector;

    const instance = lazyStore[usedSelector];
    if (instance instanceof vanillaLazy) {
      instance.update();
    } else {
      const opts = mapOptions(
        Object.assign({}, options, { selector: usedSelector })
      );
      lazyStore[usedSelector] = new vanillaLazy(opts);
    }
  });
}

function init() {
  if (window.jQuery && window.$) {
    $.fn.lazyload = function(options = {}) {
      options.container = this.context;

      return lazyload(this.selector, options);
    };
  }

  return lazyload;
}

const loader = init();

/**
 *
 * @param {*} arg1
 * @param {*} arg2
 */
function lazyLoadImages(arg1 = '', arg2 = '') {
  let trigger;
  let options;
  let customClass;

  if (arg1) {
    if (isSelector(arg1)) {
      customClass = arg1;
    } else {
      if (typeof arg1 === 'object') {
        options = arg1;
      }
    }
  }

  if (arg2) {
    if (isSelector(arg2)) {
      customClass = arg2;
    } else {
      if (typeof arg2 === 'object') {
        options = arg2;
      }
    }
  }

  if (customClass) {
    if (typeof customClass === 'string') {
      trigger = customClass || triggerClass;
    } else {
      // jquery object
      if (testJQuery(customClass)) {
        if (!customClass.length) {
          return;
        }
        trigger = customClass.selector || triggerClass;
      }
    }
  } else {
    trigger = triggerClass;
  }

  if (trigger) {
    loader(trigger, options || {});
  }
}

// we have to safe and eventually build Groupon.Utils

window.Groupon = window.Groupon || {};
window.Groupon.Utils = window.Groupon.Utils || {};
window.Groupon.Utils.lazyLoadImages = lazyLoadImages;
